<div class="col fi-p tab-fi-p sidebar first-level-menu collapse-menu" [ngClass]="{'collapse-menu' : setting && !setting.visible_sidebar,'pos-relative':!isBelowIpadSize}" *ngIf="isToken!==null">
  <div class="accordion">
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingOne">
        <button class="accordion-button" (click)="showuserMenu()" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
          <span
          class="empty-head-icon"
          *ngIf="!currentUser.user_icon"
          
        >
          {{ displayUserFirstLetter(currentUser.first_name) }}
        </span>
        <img *ngIf="currentUser.user_icon"
          [src]="profileUrl + currentUser.user_icon"
          />
          {{currentUser.first_name}}
          <span class="floating" style="display: block;
          width:25px; margin-left: auto; margin-right: auto;
          margin-top: 10px;"><i class="fa-solid fa-angle-double-down" *ngIf="!ShowDropdown"></i>
            <i class="fa-solid fa-angle-double-up" *ngIf="ShowDropdown"></i> </span>
        </button>
    
      
      </h2>
     
      <div id="collapseOne" class="accordion-collapse collapse" [ngClass]="{'show':ShowDropdown}" aria-labelledby="headingOne">
        <div class="accordion-body">
          <li>  <a class="dropdown-item" routerLink="/settings">
                <i class="fa fa-cog"></i> <span>Settings</span>
            </a>
        
            </li>
            <li><a class="dropdown-item" (click)="logout()">
              <i class="fa fa-sign-out"></i> <span>Log out</span>
            </a></li>
        </div>
      </div>
    </div>
  </div>
    
  <div class="menu">

  

    <ul>
      <!-- <li>

        <div *ngIf="isUserRole == '1'; else elseTemplate">
          <a href="https://meet.canstringai.com" target="_blank" tooltip="Meet" placement="right" >
            <i class="fa fa-video-camera"  aria-hidden="true"></i>
            <span class="" [ngClass]="{'showMeetLabel': !setting.visible_sidebar}">Meet</span>
        </a>
        </div>
        <ng-template #elseTemplate>
          <a href="https://meet.canstringai.com" target="_blank" tooltip="Join Class" placement="right" >
            <i class="fa fa-video-camera"  aria-hidden="true"></i>
            <span class="" [ngClass]="{'showMeetLabel': !setting.visible_sidebar}">Join Class</span>
        </a>
        </ng-template>

    </li> -->
      <li *ngFor="let menu of menuList; let ind = index;" class="pos-relative" id="menu_item_{{menu.id}}" (click)="removeNotifyCount(menu)">

        <a routerLink="/{{urlFormation(menu.menu_name)}}" routerLinkActive="active" *ngIf="setting.visible_sidebar">
          <small class="menu-badge" *ngIf="menu.notify_count > 0">{{menu.notify_count}}</small>
          <!-- <i class="fa {{menuIcon[menu.menu_name]}}"></i> -->
          <!-- <img src="{{menuIcon[menu.menu_name]}}"  alt=""> -->
 
          <i class="fa-solid fa-robot" *ngIf="menu.menu_name=='aiassist'"></i>
          <i class="fa-solid fa-file-text-o" *ngIf="menu.menu_name=='summarization'"></i>
          <i class="fa-solid fa-book-open" *ngIf="menu.menu_name=='elibraryandcourse'"></i>
          <i class="fa-solid fa-user" *ngIf="menu.menu_name=='user_and_group'"></i>
          <i class="fa-solid fa-message" *ngIf="menu.menu_name=='chats'"></i>
          <i class="fa-solid fa-bell" *ngIf="menu.menu_name=='channels'"></i>
          <i class="fa-solid fa-video" *ngIf="menu.menu_name=='video_quiz'"></i>
          <i class="fa-solid fa-comment-dots" *ngIf="menu.menu_name=='feedback'"></i>
          <ng-cotainer *ngIf="isUserRole!=1 && menu.menu_name==='elibraryandcourse'; else elseMenuTemplate">
          <span class="">
            E-Library
          </span>
        </ng-cotainer>
          <ng-template #elseMenuTemplate>
            <span class="">{{menu.display_menu}}</span>
          </ng-template>
        </a>

          <a routerLink="/{{urlFormation(menu.menu_name)}}" tooltip="{{menu.display_menu}}" placement="right" routerLinkActive="active"
            *ngIf="!setting.visible_sidebar">
            <small class="menu-badge" *ngIf="menu.notify_count > 0">{{menu.notify_count}}</small>
            <!-- <img src="{{menuIcon[menu.menu_name]}}"  alt=""> -->
            <!-- <i class="fa {{menuIcon[menu.menu_name]}}"></i> -->
            <i class="fa-solid fa-robot" *ngIf="menu.menu_name=='aiassist'"></i>
            <i class="fa-solid fa-file-text-o" *ngIf="menu.menu_name=='summarization'"></i>
            <i class="fa-solid fa-book-open" *ngIf="menu.menu_name=='elibraryandcourse'"></i>
            <i class="fa-solid fa-user" *ngIf="menu.menu_name=='user_and_group'"></i>
            <i class="fa-solid fa-message" *ngIf="menu.menu_name=='chats'"></i>
            <i class="fa-solid fa-bell" *ngIf="menu.menu_name=='channels'"></i>
            <i class="fa-solid fa-video"*ngIf="menu.menu_name=='video_quiz'"></i>
            <i class="fa-solid fa-comment-dots" *ngIf="menu.menu_name=='feedback'"></i>
          </a>

      </li>

    </ul>

    
  </div>

 
 
<div class="sp-collapse-wrapper">
  <div class="sp-collapse" title="Collapse Menu" (click)="hideSideMenu()">
    <i class="fa fa-angle-double-right" aria-hidden="true"></i>  
 </div>
 <span *ngIf="setting.visible_sidebar">Hide</span>
</div>
</div>

<!-- <app-player [mediaContent]="mediaContent" [inputSrc]="mediaContent.file_path" *ngIf="mediaContent"></app-player> -->
<app-player [mediaContent]="mediaContent" *ngIf="mediaContent"></app-player>
<router-outlet *ngIf="isUserLoggedIn"></router-outlet>
